import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./healthreport.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";
import Textarea from "../../../shared/components/Textarea/Textarea";
import Button from "../../../shared/components/Button/Button";
import RecordBtn from "../../../shared/components/Button/RecordBtn";
import Modal from "react-modal";

const Complaintsinitialstate = {
  Complaints: "",
  ComplaintsError: "",
};
class HealthReport extends React.Component {
  state = {
    Complaintsinitialstate,
    healthReportData: "",
    modalIsOpen: false,
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  componentDidMount() {
    let healthReportData = JSON.parse(
      localStorage.getItem("health_report_info")
    );
    this.setState({
      healthReportData:
        healthReportData &&
        healthReportData.existingHealthReports[
          healthReportData.existingHealthReports.length - 1
        ],
    });
  }
  inputchange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onSubmit = (e) => {
    e.preventDefault();
    const isvalid = this.validate();
    if (isvalid) {
      toast.info("Uploading Report...!", {
        autoClose: 2000,
      });
      const complaints_report = {
        Name: this.state.Complaints,
      };
      localStorage.setItem(
        "complaints_report_info",
        JSON.stringify(complaints_report)
      );
      console.log(this.state);
      this.setState(Complaintsinitialstate);
    }
  };

  validate = () => {
    let ComplaintsError = "";
    if (!this.state.Complaints) {
      ComplaintsError = "This field cannot be empty on submit";
    }

    if (ComplaintsError) {
      this.setState({
        ComplaintsError,
      });
      return false;
    }

    return true;
  };

  render() {
    return (
      <>
        <div className={styles.backgroundpic}>
          <div className={basestyles.inputWidth}>
            <Header name="Patient Health Report" />
            <Backicon
              onClick={() => this.props.history.goBack()}
              style={{
                background:
                  "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                color: "white",
              }}
            />
            {this.state.healthReportData === null ? (
              <div className={styles.waitinginfo}>
                <h1>Record Has Not Been Updated.....</h1>
              </div>
            ) : (
              <div className={styles.healthReport}>
                <div className={styles.center}>
                  <h3>Name - </h3>
                  <p> {this.state.healthReportData.Name} </p>
                </div>
                <div className={styles.center}>
                  <h3>Age -</h3>
                  <p> {this.state.healthReportData.Age}</p>
                </div>
                <div className={styles.center}>
                  <h3>Phone - </h3>
                  <p>{this.state.healthReportData.Phone}</p>
                </div>
                <h3>Past Medical History - </h3>
                <p>{this.state.healthReportData.PastMedicalHistory}</p>
                <h3>Medications Used Before - </h3>
                <p>{this.state.healthReportData.MedicationsUsedBefore}</p>
                <h3>Diagnostic Testing -</h3>
                <p>{this.state.healthReportData.DiagnosticTesting}</p>
                <h3>Treatment Advised - </h3>
                <p>{this.state.healthReportData.TreatmentAdvised}</p>
                <RecordBtn
                  btnName="Report an issue..?"
                  onClick={() => this.openModal()}
                  style={{
                    color: "red",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "#091135",
                    },
                  }}
                />
                <Modal
                  isOpen={this.state.modalIsOpen}
                  style={{
                    overlay: {
                      background:
                        "linear-gradient( 60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                    },
                    content: {
                      color: "#091135",
                      maxWidth: "600px",
                      margin: "0 auto",
                    },
                  }}
                >
                  <Textarea
                    placeholder="Fill out a complaint form if u have a problem..!"
                    name="Complaints"
                    value={this.state.Complaints}
                    onChange={(e) => this.inputchange(e)}
                  />
                  <div className={styles.errors}>
                    {this.state.ComplaintsError}
                  </div>

                  <Button
                    onClick={(e) => this.onSubmit(e)}
                    buttonName="Submit"
                    style={{
                      color: "white",
                      margin: "20px 15px 30px",
                      padding: "10px 10px",
                      width: "90%",
                      maxWidth: "500px",
                    }}
                  ></Button>
                  <RecordBtn
                    btnName="Close"
                    onClick={() => this.closeModal()}
                    style={{
                      padding: "10px 50px",
                      margin: "10px",
                      fontSize: "1.1rem",
                    }}
                  />
                </Modal>
                <ToastContainer />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default HealthReport;
